import { InjectionToken } from '@angular/core';

export type ExportType = 'download' | 'mail';

export type ExportListType = 'watchlist' | 'search' | 'download';

export interface ExportClickedEvent {
  list: ExportListType;
  exportTypeName: string;
  to: ExportType;
  documentId: string;
  fileName?: string;
}

export const EXPORT_API_CONFIG = new InjectionToken<string>('EXPORT_API_CONFIG');

export enum ExportDocumentStatus {
  READY = 'ready',
  FAILED = 'failed',
  LOADING = 'loading',
}

export enum ExportIdentificationStatus {
  IDENTIFIED = 'identified',
  FAILED = 'failed',
  LOADING = 'loading',
}

export interface ExportMetadata {
  name: string | null | undefined;
  size: number;
  mime: string | null;
}
